import { useMutation, useQuery } from 'react-query';
import { UserSkillsScoreService } from '@api/UserSkillsScoreService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListUserSkillsScore = (
  [id, page_no, searchText, status, startDate, endDate],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['user-skills-score-list', id, page_no, searchText, status, startDate, endDate],
    () =>
      UserSkillsScoreService.listUserSkillsScoreService({
        id,
        page_no,
        searchText,
        status,
        startDate,
        endDate
      }),
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};
// Remove
const useDeleteUserSkillsScore = () => {
  const deleteUserSkillsScore = async (userSkillsScoreId) => {
    return await UserSkillsScoreService.deleteUserSkillsScoreService(
      userSkillsScoreId
    );
  };
  return { deleteUserSkillsScore };
};

// Create
const useAddUserSkillsScore = (onSuccess, onError = onDefaultError) => {
  return useMutation(UserSkillsScoreService.addUserSkillsScoreService, {
    onSuccess,
    onError
  });
};
// Update
const useUpdateUserSkillsScore = (onSuccess, onError = onDefaultError) => {
  return useMutation(
    UserSkillsScoreService.updateUserSkillsScoreService,
    {
      onSuccess,
      onError
    }
  );
};

const useGetSkillParameterDropdown = (onSuccess, onError = onDefaultError, type = null) => {
  return useQuery(
    ['parameter-list', type], // include type in key
    () => UserSkillsScoreService.getSkillParametersListService(type), // return a function
    {
      onSuccess,
      onError
    }
  );
};

const useGetSkillOptionDropdown = (onSuccess, onError = onDefaultError) => {
  return useQuery('parameter-list', UserSkillsScoreService.getSkillScoringOptionsService, {
    onSuccess,
    onError
  });
};

const useGetSkillProgress = (userId, skillScoringParametersId, onSuccess, onError = onDefaultError) => {
  return useQuery(
    ['skill-progress', userId, skillScoringParametersId],
    () => UserSkillsScoreService.getSkillScoringProgress(userId, skillScoringParametersId),
    {
      // enabled: !!userId && !!skillScoringParametersId,
      onSuccess,
      onError
    }
  );
};

export {
  useDeleteUserSkillsScore,
  useListUserSkillsScore,
  useAddUserSkillsScore,
  useUpdateUserSkillsScore,
  useGetSkillParameterDropdown,
  useGetSkillOptionDropdown,
  useGetSkillProgress
};
